import { gql } from "@apollo/client";
import { LimitOffsetPaginationInput, LimitOffsetPaginationMeta } from "../../sharedTypes";

export interface DeviceChangeQueue {
	device_change_queue_id: number
	fk_lan_controllers: number
	fk_table_definitions: number
	fk_operation_types: number
	row_id?: number
	hw_id?: [number]
	message_type?: number
	timestamp: number
}

export interface LCDeviceChangeQueue {
	lan_controller_id: number
	device_change_queue: DeviceChangeQueuePaginationResult
}

export interface DeviceChangeQueuePaginationResult {
	data: DeviceChangeQueue[]
	meta: LimitOffsetPaginationMeta
}

export const LAN_CONTROLLERS_DEVICE_CHANGE_QUEUE = gql`
query LanControllersDeviceChangeQueue($domain: String!, $input: FetchByIdsInput!, $pagination: LimitOffsetPaginationInput!) {
	controller {
		lanControllersByIds(domain: $domain, input: $input) {
			lan_controller_id
			device_change_queue(pagination: $pagination) {
				data {
					device_change_queue_id
					fk_lan_controllers
					fk_table_definitions
					fk_operation_types
					row_id
					hw_id
					message_type
					timestamp
				}
				meta {
					limit
					offset
					hasPreviousPage
					hasNextPage
					totalCount
				}
			}
		}
	}
}
`

export interface LanControllersDeviceChangeQueueResponse {
	controller: {
		lanControllersByIds: LCDeviceChangeQueue[]
	}
}

export interface LanControllersDeviceChangeQueueArgs {
	domain: string;
	input: { ids: number[] };
	pagination: LimitOffsetPaginationInput
}

